import type {
  ReactElement,
  ReactNode,
} from 'react';

import Select from 'react-select';
import type {
  GroupBase,
  Props as SelectProps,
} from 'react-select';

import { FilterSelectBase } from '../FilterSelectBase';

import { selectComponentsSync } from '../ReactSelectExtended/filterComponents';
import type {
  OptionTypeBase,
  FilterSelectBaseProps,
} from '../ReactSelectExtended/types';

function renderSelect<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
Group extends GroupBase<OptionType>,
>(
  selectRenderProps: SelectProps<OptionType, IsMulti, Group>,
): ReactNode {
  return (
    <Select
      {...selectRenderProps}
      components={selectComponentsSync}
    />
  );
}

export type FilterSelectProps<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
Group extends GroupBase<OptionType>,
> = Omit<FilterSelectBaseProps<OptionType, IsMulti, Group>, 'renderSelect'>;

export function FilterSelect<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
Group extends GroupBase<OptionType>,
>(
  props: FilterSelectProps<OptionType, IsMulti, Group>,
): ReactElement {
  return (
    <FilterSelectBase
      {...props}
      renderSelect={renderSelect}
    />
  );
}
